import React, { FC, PropsWithChildren, ReactNode } from "react";

import { IconButton } from "@mui/material";
import { SelectionButton } from "./SelectionButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

interface SectionHeaderProps extends PropsWithChildren {
  expanded: boolean;
  setExpanded?: (expanded: boolean) => void;
  selected?: boolean;
  focused?: boolean;
  subSection?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  action?: {
    icon: ReactNode;
    onClick: () => void;
  };
}
export const SectionHeader: FC<SectionHeaderProps> = ({
  children,
  expanded,
  setExpanded,
  selected,
  focused,
  subSection,
  onMouseEnter,
  onMouseLeave,
  action,
}: SectionHeaderProps): ReactNode => {
  const subIcon = expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />;
  const expandIcon = expanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />;
  return (
    <div
      className="flex"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <SelectionButton
        isSelected={Boolean(selected)}
        isFocused={Boolean(focused)}
        subSection={subSection}
        onClick={() => setExpanded?.(!expanded)}
        startIcon={subSection && subIcon}
        endIcon={!subSection && expandIcon}
      >
        {children}
      </SelectionButton>
      {action && (
        <IconButton
          size="small"
          className="flex my-auto"
          onClick={action.onClick}
        >
          {action.icon}
        </IconButton>
      )}
    </div>
  );
};
